<div class="qa-cell-sections" [attr.aria-label]="_(KEYS.EDITOR.OPTIONS)">
  <button type="button" [class.active]="activeSection === 'scoring'" [attr.aria-pressed]="activeSection === 'scoring'"
          (click)="activeSection = 'scoring'"><i class="fa fa-sort-numeric-asc" aria-hidden="true"></i> {{_(KEYS.EDITOR.SCORING)}}</button>
  <button type="button" [class.active]="activeSection === 'variables'" [attr.aria-pressed]="activeSection === 'variables'"
          (click)="activeSection = 'variables'; variablesOpened = true"><i class="fa fa-code" aria-hidden="true"></i> {{_(KEYS.EDITOR.VARIABLES)}}</button>
</div>
<div [hidden]="activeSection !== 'scoring'">
  <button type="button" class="qa-cell-empty qa-cell-scoring-link" *ngIf="!scoringNames.length"
          (click)="openScoringVariables()">{{_(KEYS.EDITOR.MATRIX_NO_SCORING)}}
    <i class="fa fa-arrow-right" aria-hidden="true"></i>
  </button>
  <div class="qa-cell-scoring" *ngIf="scoringNames.length">
    <label class="qa-cell-score-name">{{_(KEYS.EDITOR.SCORING_VARIABLE)}}
      <select class="form-control" [(ngModel)]="selectedScore" (keydown)="onScoreKeyDown($event)">
        <option [ngValue]="null">{{_(KEYS.EDITOR.PLEASE_SELECT)}}</option>
        <option *ngFor="let name of scoringNames" [ngValue]="name">{{name}}</option>
      </select>
    </label>
    <label class="qa-cell-score-value">{{_(KEYS.EDITOR.SCORING_VALUE_FOR_THIS_ANSWER)}}
      <input class="form-control" type="number" step="any" [(ngModel)]="scoreValue" (keydown)="onScoreKeyDown($event)" [disabled]="!selectedScore">
    </label>
    <div class="qa-cell-score-actions">
      <button type="button" class="btn btn-primary" [disabled]="!canSaveScore()" (click)="saveScore()">
        <i class="fa fa-save" aria-hidden="true"></i> {{_(KEYS.EDITOR.SAVE)}}
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="resetScore()"
              [attr.aria-label]="_(KEYS.EDITOR.RESET)" [ngbTooltip]="_(KEYS.EDITOR.RESET)" container="body">
        <i class="fa fa-undo" aria-hidden="true"></i>
      </button>
      <button type="button" class="btn btn-outline-danger" [disabled]="!hasSavedScore()" (click)="deleteScore()"
              [attr.aria-label]="_(KEYS.EDITOR.REMOVE)" [ngbTooltip]="_(KEYS.EDITOR.REMOVE)" container="body">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>
<div [hidden]="activeSection !== 'variables'">
  <app-qa-variables *ngIf="variablesOpened" [container]="container" [disabledScopes]="disabledScopes"></app-qa-variables>
</div>
